import { useEffect } from "react";

interface GoogleTagManagerProps {
  gtmId: string;
}

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

let gtmScriptAdded = false;

function addGtmScript(gtmId: string) {
  if (!gtmId || gtmScriptAdded) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "gtm.js",
    "gtm.start": new Date().getTime(),
  });

  const firstScript = document.getElementsByTagName("script")[0];
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  firstScript?.parentNode?.insertBefore(script, firstScript);

  gtmScriptAdded = true;
}

export function GoogleTagManager({ gtmId }: GoogleTagManagerProps) {
  useEffect(() => {
    if (!gtmId) return;
    addGtmScript(gtmId);
  }, [gtmId]);

  if (!gtmId) return null;

  return (
    <noscript>
      <iframe
        title="Google Tag Manager"
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
      />
    </noscript>
  );
}
